import { checkDefined } from 'faro-common-model';
/**
 * These are the allowed constraints that may be applied to a {@link DynamicFieldEntityReferenceDefinition}
 *
 * Note: this is not fully developed; each of these needs support in both the back-end validator AND
 *      front-end Dynamic Field Manager configuration UX form fields AND
 *      front-end Dynamic Field Definition Manager UX when modifying DynamicFieldDefinition expressions/references
 */
export var DynamicFieldReferenceConstraintType;
(function (DynamicFieldReferenceConstraintType) {
    // Activity constraints
    DynamicFieldReferenceConstraintType["ScheduledDayActivities"] = "ScheduledDay.Activities";
    // ScheduledDay constraints
    DynamicFieldReferenceConstraintType["ActivityDays"] = "Activity.Days";
})(DynamicFieldReferenceConstraintType || (DynamicFieldReferenceConstraintType = {}));
export function toDynamicFieldReferenceConstraint(constraint) {
    checkDefined(constraint.code, 'DynamicFieldReferenceConstraint', 'code');
    checkDefined(constraint.type, 'DynamicFieldReferenceConstraint', 'type');
    return {
        code: constraint.code,
        type: constraint.type,
    };
}
//# sourceMappingURL=dynamic-field-reference-constraint.js.map